export default __webpack_public_path__ + "static/media/searching.fcd83630.svg";